module.exports = __webpack_public_path__ + "img/collection_b.00e615fe.png";